import { Wrapper } from './EmptyItem.styled';

export const EmptyItem = () => {
  return <Wrapper data-name="empty-item" />;
};
